const links = [
  { title: '热门板块', items: ['社区广场', '数码研究所', '影视瓜田', '职场茶水间'] },
  { title: '内容分类', items: ['生活圈', '兴趣圈', '分享圈', '表达圈'] },
  { title: '了解海角', items: ['关于社区', '板块入驻', '用户协议', '联系我们'] },
];

export default function Footer() {
  return (
    <footer className="bg-[#fff7ed]">
      <div className="mx-auto max-w-[1240px] px-4 py-10 md:px-6 md:py-12">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-5">
          <div className="col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-orange-600 text-white">
                <i className="ri-sun-line text-lg"></i>
              </span>
              <span className="text-lg font-bold tracking-tight text-stone-900">海角社区</span>
            </div>
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-stone-500">
              汇聚热门板块、广场今日话题与分类圈子的中文讨论社区，带你快速摸清板块节奏，找到想聊的话题。
            </p>
            <div className="mt-4 flex gap-2">
              <a href="#top" aria-label="微博" className="flex h-8 w-8 items-center justify-center rounded-full bg-white text-stone-500 transition-colors hover:bg-orange-100 hover:text-orange-600">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#top" aria-label="微信" className="flex h-8 w-8 items-center justify-center rounded-full bg-white text-stone-500 transition-colors hover:bg-orange-100 hover:text-orange-600">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#top" aria-label="抖音" className="flex h-8 w-8 items-center justify-center rounded-full bg-white text-stone-500 transition-colors hover:bg-orange-100 hover:text-orange-600">
                <i className="ri-tiktok-fill"></i>
              </a>
              <a href="#top" aria-label="哔哩哔哩" className="flex h-8 w-8 items-center justify-center rounded-full bg-white text-stone-500 transition-colors hover:bg-orange-100 hover:text-orange-600">
                <i className="ri-play-circle-line"></i>
              </a>
            </div>
          </div>

          {links.map((l) => (
            <div key={l.title}>
              <h4 className="text-sm font-bold text-stone-900">{l.title}</h4>
              <ul className="mt-3 space-y-2">
                {l.items.map((it) => (
                  <li key={it}>
                    <a href="#top" className="whitespace-nowrap text-sm text-stone-500 transition-colors hover:text-orange-600">
                      {it}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-stone-200 pt-6 sm:flex-row">
          <p className="text-xs text-stone-400">© 2026 海角社区 · 内容仅作演示展示</p>
          <p className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs text-stone-400">
            <a href="#top" className="hover:text-orange-600">用户协议</a>
            <a href="#top" className="hover:text-orange-600">隐私政策</a>
            <a href="#top" className="hover:text-orange-600">内容规范</a>
            <a href="#download" className="flex items-center gap-1 rounded-full bg-orange-600 px-3 py-1 font-medium text-white hover:bg-orange-700">
              <i className="ri-download-2-line"></i> 下载客户端
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}